<div class="c-product row  mt-25">
    <div class="col-9 p-0">
        <div class="titulo-producto">
            {{product.title}}
        </div>
    </div>
    <div class="col-3 p-0 align-self-end" (click)="toggle()" *ngIf="!bloquearCantidad">
        <img *ngIf="!isClicked" class="icn-arrow-down c-mover-derecha" src="./assets/icons/icon-arrow-down.svg">
        <img *ngIf="isClicked" class="icn-arrow-down c-mover-derecha" src="assets/icons/icon-arrow-up.svg">
    </div>
    <div *ngIf="container" class="conteiner-blanco"></div>
    <ng-container *ngIf="product.isOpen">
        <div class="col-12 c-product-detail ">
            <div class="row mt-27 ">
                <div class="col-6 p-0">
                    <div
                     class="c-texto__carro--producto">Tipo de venta  </div>
                </div>
                <div 
                class="col-6  p-0 c-texto__carro--valor"> {{product.tipoVenta | tipoVenta}} </div>
            </div>                       

            <div class="row">
                <div class="col align-self-start">
                </div>
                <div class="col align-self-end jus-right">
                    <i *ngIf="!bloquearCantidad" class="icon-eliminar c-mover-derecha" (click)="deleteProduct()"></i>
                </div>
            </div>
        </div>
    </ng-container>   
</div>
